export const PathNames = {
  CREATE_ACCOUNT: '/create-account',
  CREATE_DEV_ACCOUNT: '/create-dev-account',
  EMBEDDED_CUSTOMER_TERMS: '/embedded-customer-terms',
  LOGIN: '/login',
  LOGOUT: '/logout',
  NOT_AVAILABLE_IN_COUNTRY: '/not-available',
  VERIFICATION: '/verification',
}
